export enum AmplitudeDomain {
    Time = 0,
    Depth = 1
}